export default class TutorialOverlayMediatorEvent { }

TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED = "TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED";
TutorialOverlayMediatorEvent.FINISH_BUTTON_CLICKED = "TutorialOverlayMediatorEvent.FINISH_BUTTON_CLICKED";